import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../shared/services/dialog.service';
import { ViewInvoicesService } from './view-invoices.service';
import { InvoiceModel } from '../../models/view-invoices/invoice.model';
import { AppMessages } from '../../shared/constants/messages';
import { AppConstants } from './../../shared/constants/constants';
import { ShareService } from '../../shared/services/share.service';

@Component({
  selector: 'app-view-invoices',
  templateUrl: './view-invoices.component.html',
  providers: [ViewInvoicesService]
})
export class ViewInvoicesComponent implements OnInit {
  consultations = [];
  viewModel = {
    consultationId: null
  };
  invoices = new Array<InvoiceModel>();
  public title: string;
  public appConstants = AppConstants;
  public message: string = '';
  constructor(
    public dialogService: DialogService,
    public vInvoiceService: ViewInvoicesService,
    public shareServices: ShareService
  ) {
    this.title = 'View Invoices';
    this.getAllConsultations();
  }

  ngOnInit() {
  }

  getAllConsultations() {
    this.vInvoiceService.getAllConsultations().subscribe(res => {
      if (res) {
        const data = res.json();
        this.consultations = data;
        if (this.consultations) {
          if (this.consultations.length > 0) {
            this.viewModel.consultationId = null;
            this.getInvoicesByConsultationId(this.viewModel.consultationId);
          } else {
            this.message = AppMessages.viewInvoice.noConsultation;
          }
        }
      }
    });
  }

  getInvoicesByConsultationId(consultationId) {
    consultationId = consultationId == null || consultationId === 'null' ? "00000000-0000-0000-0000-000000000000" : consultationId;
    this.vInvoiceService.getInvoicesByConsultationId(consultationId).subscribe(res => {
      if (res) {
        const data = res.json();
        this.invoices = data;
        this.message = !this.invoices || this.invoices.length < 1 ? AppMessages.viewInvoice.noInvoice : '';
      }
    });
  }

  changeConsultation(consultationId) {
    if (consultationId) {
      this.getInvoicesByConsultationId(consultationId);
    }
  }

  onOpenInvoice(invoice) {
    const params = {
      [AppConstants.reportParameter.InvoiceNo]: invoice.invoiceNumber,
      [AppConstants.reportParameter.currency]: invoice.defaultCurrencyCode
    };
    this.shareServices.showReport('Invoice', params, invoice.centreId);
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-invoices/view-invoices.component.ts